import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import * as auth from './redux/AuthRedux'
import {logoutBackend} from './redux/AuthCRUD'
import { useHistory } from 'react-router-dom'

export function Logout() {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const handleLogout = async () => {
      // Blacklist the refresh JWT server-side and clear the HttpOnly cookie
      // before we tear down the local session -- otherwise the cookie would
      // linger and could be reused if someone recovered it from disk cache.
      await logoutBackend()

      localStorage.removeItem('persist:v100-demo1-auth')
      localStorage.removeItem('accessToken')

      dispatch(auth.actions.logout())

      await new Promise((resolve) => setTimeout(resolve, 100))
      history.push('/auth/login')
    }

    handleLogout()
  }, [dispatch])

  return null
}
